import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useStore } from '../store';
import { DEFAULT_PAGE_SIZE } from '../utils/constants';

export function usePersistentPagination(
  pageFilterInstanceId: string,
  widgetFilterInstanceId: string,
  defaultPageSize = DEFAULT_PAGE_SIZE
) {
  const [currentPageStore, setCurrentPageStore] = useStore(
    useShallow((state) => [
      state.pagination[pageFilterInstanceId]?.[widgetFilterInstanceId]?.page ??
        0,
      state.setPage,
    ])
  );
  const setCurrentPage = useCallback(
    (page: number) => {
      setCurrentPageStore(pageFilterInstanceId, widgetFilterInstanceId, page);
    },
    [setCurrentPageStore, widgetFilterInstanceId, pageFilterInstanceId]
  );

  const [currentPageSizeStore, setCurrentPageSizeStore] = useStore(
    useShallow((state) => [
      state.pagination[pageFilterInstanceId]?.[widgetFilterInstanceId]
        ?.perPage ?? defaultPageSize,
      state.setPerPage,
    ])
  );
  const setCurrentPageSize = useCallback(
    (perPage: number) => {
      setCurrentPageSizeStore(
        pageFilterInstanceId,
        widgetFilterInstanceId,
        perPage
      );
    },
    [setCurrentPageSizeStore, widgetFilterInstanceId, pageFilterInstanceId]
  );

  return {
    currentPage: currentPageStore,
    currentPageSize: currentPageSizeStore,
    setCurrentPage,
    setCurrentPageSize,
  };
}
